import {
  provideSoftAppsModule,
  withSoftAppsModuleInfo,
  withSoftAppsModuleRoutes,
  withSoftAppsModuleTranslation,
} from '@softapps/core';
import { getModuleGroupByName } from '@softline/application';
import { default as de } from '../i18n/de.json';
import { purchaseStatisticsRoutes } from './purchase-statistics.routes';

export const SOFTLINE_PERMISSION_WWS_PURCHASE_STATISTICS =
  'SOFTAPPS.WWS_PURCHASE_STATISTICS';

export const providePurchaseStatisticsModule = () => {
  return [
    provideSoftAppsModule(
      {
        name: 'PurchaseStatistics',
        title: 'Einkaufsstatistik',
        icon: 'fa-regular fa-chart-pie-simple-circle-dollar',
        route: '/purchase-statistics/dashboard',
        permission: SOFTLINE_PERMISSION_WWS_PURCHASE_STATISTICS,
        group: getModuleGroupByName('Statistik'),
      },
      withSoftAppsModuleRoutes({ app: purchaseStatisticsRoutes }),
      withSoftAppsModuleTranslation({ de }),
      withSoftAppsModuleInfo({
        library: '@softapps/wws/purchase-statistics',
        description: 'Einkaufsstatistik nach Lieferant und Artikel.',
      })
    ),
  ];
};
